<template>
  <section class="search-destination-container">
    <div class="search-destination-wrapper">
      <div class="search-destination-row destination-wrapper">
        <div
          id="destination-mobile"
          class="search-destination-regions destination-mobile"
        >
          <div class="search-filter-title destination__trigger">
            <p
              class="dropdown-subheading is-dektop"
              v-text="filterTripsContent.destination.regionDisplayText"
            />
            <p
              class="dropdown-subheading is-mobile"
              v-text="
                selectedRegionMobile === ''
                  ? filterTripsContent.destination.regionDisplayText
                  : selectedRegionMobile
              "
            />
            <div class="arrow" />
          </div>
          <ul class="region-list custom-options">
            <li
              v-for="(continent, continentIndex) in filterTripsContent.destination.continents"
              class="region-item"
            >
              <a
                :key="'continent' + continentIndex"
                class="button highlight search-destination-item custom-option"
                :data-tabindex="continentIndex"
                :class="[
                  continentIndex === currentTab && selectedRegion === currentDestination
                    ? 'selected is-active'
                    : '',
                  !selectedRegion && !selectedDestinations.length ? 'not-selected' : ''
                ]"
                :data-continent="true"
                :data-region-id="continentIndex"
                :data-target="'#' + continent.continentName"
                :data-searchterm="continent.continentApiName"
                href="#"
                @click.prevent="regionClick"
              >
                {{ continent.continentName }}
              </a>
            </li>
          </ul>
        </div>

        <div class="search-destination-countries">
          <div
            v-for="(continent, continentIndex) in filterTripsContent.destination.continents"
            :key="continentIndex"
            class="search-destination-country-container"
          >
            <div
              v-if="continentIndex === currentTab"
              class="search-destination-region-wrapper"
            >
              <div class="search-filter-title">
                <p
                  class="dropdown-subheading"
                  v-text="countriestext"
                />
                <a
                  class="search-destination-item search-all-header"
                  :class="{
                    'is-active selected': continentIndex === currentTab && regionSearchSelected
                  }"
                  :data-continent="true"
                  :data-display-value="continent.continentName"
                  :data-region-id="continentIndex"
                  :value="continent.continentApiName"
                  :data-searchterm="continent.continentApiName"
                  href="#"
                  @click.prevent="regionSearchAndApply(continent, continentIndex)"
                >
                  Search all in
                  {{ continent.continentName }}
                </a>
              </div>
              <div
                v-if="continent.countries"
                class="country-holder"
              >
                <ul class="search-destination-column">
                  <li
                    v-for="(country, index) in continent.countries"
                    :key="'country' + index"
                    class="country-item"
                    :class="[
                      continent.hasTopCountries && country.isTopCountry
                        ? 'is-top-country'
                        : !continent.hasTopCountries
                          ? ''
                          : 'no-top-country',
                      showAll ? 'showCountry' : ''
                    ]"
                  >
                    <button
                      :data-display-value="country.countryApiName"
                      :data-region-id="continentIndex"
                      :value="country.countryApiName"
                      class="country-item-btn search-destination-item"
                      @click="selectedCountries($event, continent, continentIndex)"
                    >
                      {{ country.countryName }}
                    </button>
                  </li>
                </ul>
                <div v-if="continent.hasTopCountries">
                  <button
                    v-if="!showAll"
                    class="show-countries"
                    @click="showAllCountries"
                  >
                    Show All Countries
                  </button>
                  <button
                    v-if="showAll"
                    class="show-countries"
                    @click="showTopCountries"
                  >
                    Show Top Countries
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import eventBus from '../../vue-functions/event-bus';

export default {
  props: [
    'filterTripsContent',
    'destinations',
    'continent',
    'searchtype',
    'countriestext',
    'locked',
    'filterActions',
    'currentRegionSelected'
  ],
  data() {
    return {
      currentTab: 0,
      selectedDestinations: [],
      buttonActiveClass: 'is-active',
      selectedRegion: false,
      selectedRegionMobile: false,
      regionSearchSelected: false,
      destinationValues: null,
      showAll: false,
      currentDestination: ''
    };
  },
  watch: {
    destinations(newVal) {
      this.destinationValues = newVal;
    },
    continent(newVal) {
      this.selectedRegion = newVal;
    }
  },
  mounted() {
    const continents = this.filterTripsContent?.destination?.continents;
    if (!continents || continents.length === 0) return;

    const defaultContinent = continents[0];

    this.currentTab = 0;
    this.currentDestination = defaultContinent.continentApiName;
    this.selectedRegion = defaultContinent.continentApiName;
    this.selectedRegionMobile = defaultContinent.continentName;

    this.regionSearchSelected = true;

    if (this.destinations && this.destinations.length > 0) {
      this.destinationValues = this.destinations;
      this.updateDestinations();
      this.regionSearchSelected = false;
    }

    this.$nextTick(() => {
      if (!this.locked) {
        this.setButtonActiveStates();
      }
    });
  },
  created() {
    eventBus.$on('destinations-set-active-states', () => {
      this.setButtonActiveStates();
    });
    eventBus.$on('destinations-clear-values', () => {
      this.clearValues();
    });
    eventBus.$on('set-values-from-search-input', (searchType) => {
      this.setValuesFromSearchInput(searchType);
    });
  },
  methods: {
    updateDestinations() {
      const splitDestinationValues = this.destinationValues?.split(',') || [];
      for (const val of splitDestinationValues) {
        const decoded = decodeURIComponent(val);
        if (!this.selectedDestinations.includes(decoded)) {
          this.selectedDestinations.push(decoded);
        }
      }
    },
    regionClick(event) {
      const btn = event.currentTarget;
      const tabIndex = parseInt(btn.dataset.tabindex, 10);
      const regionSearchTerm = btn.dataset.searchterm;

      this.currentTab = tabIndex;
      this.selectedRegion = regionSearchTerm;
      this.selectedRegionMobile = btn.dataset.target.substring(1);
      this.currentDestination = regionSearchTerm;

      this.regionSearchSelected = this.selectedDestinations.length === 0;

      if (this.regionSearchSelected) {
        this.$parent.$emit('destinations-region-search', this.selectedRegion);
      }

      this.$nextTick(() => {
        this.setButtonActiveStates();
      });
    },
    regionSearch(event) {
      const btn = event.currentTarget;

      this.selectedRegion = btn.dataset.searchterm;
      this.currentDestination = btn.dataset.searchterm;

      if (this.selectedDestinations.length === 0) {
        this.regionSearchSelected = true;
        this.clearValues();
        this.$parent.$emit('destinations-region-search', this.selectedRegion);
      }

      this.$nextTick(() => {
        this.setButtonActiveStates();
      });
    },
    regionSearchAndApply(continent, index) {
      this.currentTab = index;
      this.selectedRegion = continent.continentApiName;
      this.currentDestination = continent.continentApiName;
      this.selectedRegionMobile = continent.continentName;

      this.selectedDestinations = [];
      this.regionSearchSelected = true;
      this.showAll = false;

      this.$parent?.$emit('destinations-region-search', this.selectedRegion);

      this.$nextTick(() => {
        this.setButtonActiveStates();
      });

      // Trigger same apply as "Apply Selection" button
      this.$parent?.$emit('filter-search');
    },
    selectedCountries(event, continent, tab) {
      const value = event.target.value;

      if (this.selectedDestinations.includes(value)) {
        this.selectedDestinations = this.selectedDestinations.filter((d) => d !== value);
        event.target.classList.remove(this.buttonActiveClass);
      } else {
        this.selectedDestinations.push(value);
        event.target.classList.add(this.buttonActiveClass);
      }

      this.currentTab = tab;
      this.regionSearchSelected = false;
      this.selectedRegion = continent.continentApiName;
      this.currentDestination = continent.continentApiName;

      this.$parent.$emit('destinations-filter', this.selectedDestinations);
    },
    clearValues() {
      this.selectedDestinations = [];
      this.showAll = false;

      // Clear selected region state (will prevent region buttons from getting is-active)
      this.selectedRegion = false;
      this.currentDestination = '';
      this.selectedRegionMobile = '';
      this.regionSearchSelected = false;

      const buttons = this.getButtonDomRefs();
      for (const btn of buttons) {
        btn.classList.remove(this.buttonActiveClass);
      }

      // Keep currentTab as-is so user sees last open continent’s countries

      this.$nextTick(() => {
        this.setButtonActiveStates();
      });

      this.$parent?.$emit('clear-destinations', this.selectedRegion);
    },
    setValuesFromSearchInput(searchType) {
      if (searchType === 'region') {
        this.regionSearchSelected = true;
        this.$nextTick(() => {
          this.setButtonActiveStates();
        });
      } else {
        this.$nextTick(() => {
          this.updateDestinations();
          this.regionSearchSelected = false;
          this.setButtonActiveStates();
        });
      }
    },
    getButtonDomRefs() {
      const region = document.querySelector('.search-destination-wrapper');
      if (region) {
        return region.querySelectorAll('.search-destination-item');
      }
      return [];
    },
    setButtonActiveStates() {
      const buttons = this.getButtonDomRefs();
      if (!buttons || buttons.length === 0) return;

      for (const btn of buttons) {
        const btnValue = btn.value;
        const btnDisplayValue = btn.dataset.displayValue;

        // Always reset active class
        btn.classList.remove(this.buttonActiveClass);

        // Country buttons: highlight if selected
        if (
          this.selectedDestinations.includes(btnValue) ||
          this.selectedDestinations.includes(btnDisplayValue)
        ) {
          btn.classList.add(this.buttonActiveClass);
        }

        // Region buttons: highlight if they match currentTab
        if (btn.dataset.continent === 'true') {
          const regionTabIndex = parseInt(btn.dataset.regionId, 10);
          if (regionTabIndex === this.currentTab && this.selectedRegion) {
            btn.classList.add(this.buttonActiveClass);
          }
        }
      }
    },
    showAllCountries() {
      this.showAll = true;
    },
    showTopCountries() {
      this.showAll = false;
    }
  }
};
</script>
